import { useFormik } from "formik";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  //useState,
} from "react";
//import toast from "react-hot-toast";
//import { userFormValidate } from "../../../../helper/validate";

//import * as api from "helper/helper";
//import invalidClass from "../../helperFunctions/helpers";
import AddressView from "./AddressView";

const CreateAddressModal = forwardRef(
  ({ item, onOk, reloadDireccion, returnToModalId }, ref) => {
    const modalButtonRef = useRef();
    const modalReturnButtonRef = useRef();
    const addressViewRef = useRef();
    const dismissBtnRef = useRef();
    ///  const [returnToModalId, setReturnToModalId] = useState();

    const createMode = item == null || (item && Object.keys(item).length === 0);
    const modalCreateAddressId = "modalCreateAddress";
    const targetModalCreateAddressId = `#${modalCreateAddressId}`;

    const targetReturnToModalId = `#${returnToModalId}`;

    useImperativeHandle(ref, () => ({
      toggleModal: () => {
        formik?.resetForm();
        modalButtonRef.current.click();
      },
      modalId: () => {
        return modalCreateAddressId;
      },
    }));

    const formik = useFormik({
      initialValues: {},
      enableReinitialize: true,
      //validate: userFormValidate,
      validateOnBlur: false,
      validateOnChange: false,
      onSubmit: async (values) => {
        //is - invalid;

        let newItem = addressViewRef.current.getValues();
        reloadDireccion(newItem);
        formik.resetForm();
      },
    });

    return (
      <>
        {/*<!-- Button trigger modal -->*/}
        <button
          ref={modalButtonRef}
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target={targetModalCreateAddressId}
          hidden
        >
          Launch static backdrop modal
        </button>

        {/*<!-- Modal -->*/}
        <div
          className="modal fade"
          id={modalCreateAddressId}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropCreateAddressLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="modal-title"
                  id="staticBackdropCreateAddressLabel"
                >
                  {createMode ? "Crear" : "Editar"} Dirección
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  data-bs-target={targetReturnToModalId}
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <AddressView ref={addressViewRef} item={item} />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  data-bs-target={targetReturnToModalId}
                >
                  Cancelar
                </button>
                <button
                  ref={dismissBtnRef}
                  className="btn btn-primary"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  data-bs-target={targetReturnToModalId}
                  hidden
                ></button>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() => {
                    if (addressViewRef.current.validate()) {
                      formik.handleSubmit();
                      dismissBtnRef.current.click();
                    }
                  }}
                >
                  {createMode ? "Crear" : "Editar"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <a
          ref={modalReturnButtonRef}
          className="btn btn-primary"
          data-bs-toggle="modal"
          href={targetReturnToModalId}
          role="button"
          hidden
        >
          Regresa modal
        </a>
      </>
    );
  },
);

export default CreateAddressModal;
